import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { SITE_URL } from '@goodfellas/environment'

const BASE = SITE_URL.replace(/\/+$/, '')

/** Prefixa o path com o locale (locale padrão fica sem prefixo). */
export function localePath(
  path: string,
  locale?: string,
  defaultLocale?: string,
): string {
  const clean = path === '/' ? '' : path
  if (!locale || locale === defaultLocale) return clean || '/'
  return `/${locale}${clean}`
}

/**
 * Alternates hreflang para todas as línguas do site (mesmas do app) — ajuda
 * o Google a servir a versão certa de cada página indexável.
 */
export function HrefLangs({ path }: { path: string }) {
  const { locales, defaultLocale } = useRouter()
  if (!locales) return null

  return (
    <Head>
      {locales.map((locale) => (
        <link
          key={locale}
          rel="alternate"
          hrefLang={locale === 'pt' ? 'pt-BR' : locale}
          href={`${BASE}${localePath(path, locale, defaultLocale)}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${BASE}${localePath(path, defaultLocale, defaultLocale)}`}
      />
    </Head>
  )
}
